module.exports = new __parcel__URL__("stripe-terminal-verifone-default-splash.fb1fdd3d.png").toString();